
export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              About ZÓNA s.r.o.
            </h2>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              ZÓNA s.r.o. is a leading technology company based in Slovakia, specializing in developing cutting-edge VPN applications that prioritize user privacy and security. Our mission is to provide individuals and businesses with reliable, fast, and secure internet access.
            </p>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              We understand the importance of online privacy in today's digital world. That's why we've built our VPN solution with the most advanced encryption technologies and a strict no-log policy to ensure your data remains private and secure at all times.
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Our team of experienced developers and security experts continuously work to improve our VPN service, ensuring you always have access to the best protection available. Whether you're browsing, streaming, or working remotely, ZÓNA s.r.o. keeps you safe online.
            </p>
            <div className="flex flex-wrap gap-4">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                  <i className="ri-shield-check-fill text-2xl text-blue-600"></i>
                </div>
                <div>
                  <div className="font-bold text-gray-900">Secure</div>
                  <div className="text-sm text-gray-600">Military-grade encryption</div>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                  <i className="ri-speed-fill text-2xl text-green-600"></i>
                </div>
                <div>
                  <div className="font-bold text-gray-900">Fast</div>
                  <div className="text-sm text-gray-600">Optimized servers</div>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center">
                  <i className="ri-user-heart-fill text-2xl text-purple-600"></i>
                </div>
                <div>
                  <div className="font-bold text-gray-900">Trusted</div>
                  <div className="text-sm text-gray-600">Privacy-focused</div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/81b0f2e16ccf8acdf102e7f215d13712.jpg"
              alt="ZÓNA s.r.o. VPN Technology"
              className="rounded-2xl shadow-2xl w-full h-auto object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
